import React from 'react';

import { Heading } from '../../../../../../../components/Heading/Heading';
import { WarningIcon } from '../../../../../../../components/Icons/WarningIcon';
import { RegulationLocationContent } from '../../../../../../../components/RegulationLocationCard/RegulationLocationContent';
import { Text } from '../../../../../../../components/Text/Text';
import { IBoundary } from '../../../../../../../helpers/hooks/fishrules/useRegulationBoundaryAtLocation';
import { ICoordinates } from '../../../../../../../interfaces/geo';

interface IRegulationListHeaderProps {
  boundaries: IBoundary[] | undefined;
  coordinates: ICoordinates | undefined;
  boundaryName: string | undefined;
  isProhibited: boolean;
  message: string | undefined;
}

export const RegulationViewHeader = ({
  boundaries,
  coordinates,
  boundaryName,
  isProhibited,
  message,
}: IRegulationListHeaderProps) => {
  return (
    <div className="flex flex-col bg-lake-fog">
      <Heading variant="sm">Regulations</Heading>
      <div className="pb-4">
        {boundaries && boundaries.length > 0 && (
          <RegulationLocationContent
            coordinates={coordinates}
            boundaryName={boundaryName}
            boundaries={boundaries}
          />
        )}
        {isProhibited && (
          <div className="mb-6">
            <div className="flex items-center">
              <WarningIcon />
              <Text variant="md" className="mb-0 ml-1 text-error-shade">
                Protected area
              </Text>
            </div>
            <Text className="my-6 text-error-shade" variant="md">
              {message || 'It is unlawful to fish in these waters'}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};
